import * as _ from 'lodash'
import {
    WB_WorkspaceReportDimensionRow, WB_ConnectionRow
} from "../PA.Core/PAdbSchemaRows";
import {
    IConnection,
    IDimensionDataProvider, IDimensionSelector, IHierarchyNode
} from "../PA.Reporting.Core/PA.Reporting.IF";
import {WorkspaceBO} from "./WorkspaceBO";
import {DimensionDataService} from "../PA.Reporting.Services/DimensionDataService"
import {DimensionSelector} from "../PA.Reporting.Core/DimensionSelector";

var bDebugWithMockProvider = false
import {MockDimensionDataProvider} from "../PA.UIM.Reporting/MockDimensionDataProvider";
import {JSONUtils} from "../PA.Core/Basic/JSON";

export class WorkspaceBOIWorkspaceReportDimensionSelector
    extends DimensionSelector {

    private _WorkspaceBO: WorkspaceBO
    private _WorkspaceReportDimensionRow: WB_WorkspaceReportDimensionRow


    constructor(aWS_BO: WorkspaceBO,
                aWS_ReportDimension: WB_WorkspaceReportDimensionRow,
                parentSelector?: IDimensionSelector) {

        let aDimRow = aWS_ReportDimension.WB_DimensionRow
        let aDimension = {
            DimensionId: aDimRow.cif.DIMENSION_ID,
            DimensionName: aDimRow.cif.DIMENSION_NAME,
            DimensionTechnicalName: aDimRow.cif.TECHNICAL_NAME,
            DimensionRenderOptions: JSONUtils.parse(aDimRow.cif.RENDER_OPTIONS, {})
        }

        let aWB_Connnection: WB_ConnectionRow = aDimRow.WB_ConnectionRow

        let aConnection: IConnection = {
            ConnectionId: aWB_Connnection.cif.CONNECTION_ID,
            ConnectionTypeId: aWB_Connnection.cif.CONNECTION_TYPE_ID,
            ConnectionName: aWB_Connnection.cif.CONNECTION_NAME,
            ConnectionOptions: JSONUtils.parse(aWB_Connnection.cif.CONNECTION_OPTIONS, {})
        }

        let aDimensionDataProvider: IDimensionDataProvider
        if (bDebugWithMockProvider) {
            aDimensionDataProvider = new MockDimensionDataProvider()
        } else {
            aDimensionDataProvider = new DimensionDataService(aConnection, aDimension);
        }

        let lockedToPrnt: boolean = (aWS_ReportDimension.cif.LOCKED_IND == '1')

        super(aDimension, aDimensionDataProvider, aWS_ReportDimension.cif.SELECTEDHIERARCHY, aWS_ReportDimension.cif.SELECTEDKEYS.split('|'), parentSelector, lockedToPrnt, aWS_BO.WB_Workspace.WB_SALESORG_ID)

        this._WorkspaceBO = aWS_BO
        this._WorkspaceReportDimensionRow = aWS_ReportDimension

        this.OnHierarchySelectedChanged.subscribe((aDimensionSelector: WorkspaceBOIWorkspaceReportDimensionSelector) => {
            if (_.isEmpty(aDimensionSelector)) {
                return
            }
            aDimensionSelector.saveSelectedHierarchy()
        })

        this.OnHierarchyNodesSelectedChanged.subscribe((aDimensionSelector: WorkspaceBOIWorkspaceReportDimensionSelector) => {
            if (_.isEmpty(aDimensionSelector)) {
                return
            }
            this.WBSalesOrgId = aWS_BO.WB_Workspace.WB_SALESORG_ID
            aDimensionSelector.saveSelectedHierarchyNodes()
        })

    }

    // Called before BO Save.
    saveSelections() {
        this.saveLockToParent()
        this.saveSelectedHierarchy()
        this.saveSelectedHierarchyNodes()
    }


    // Called when changes are emitted
    saveLockToParent() {
        if (this.LockSelectionToParent) {
            this._WorkspaceReportDimensionRow.cif.LOCKED_IND = '1'
        } else {
            this._WorkspaceReportDimensionRow.cif.LOCKED_IND = '0'
        }
    }

    saveSelectedHierarchy() {
        if (_.isEmpty(this.HierarchySelected)) {
            this._WorkspaceReportDimensionRow.cif.SELECTEDHIERARCHY = ''
        } else {
            this._WorkspaceReportDimensionRow.cif.SELECTEDHIERARCHY = (this.HierarchySelected && (this.HierarchySelected.HierarchyId).toString()) || ''
        }
    }

    saveSelectedHierarchyNodes() {
        if (_.isEmpty(this.HierarchyNodesSelected)) {
            this._WorkspaceReportDimensionRow.cif.SELECTEDKEYS = ''
        } else {
            this._WorkspaceReportDimensionRow.cif.SELECTEDKEYS = _.map(this.HierarchyNodesSelected, (aNode: IHierarchyNode) => {
                return aNode.NodeId
            }).join('|')
        }

    }

}
